import { render, staticRenderFns } from "./StudioPodcastDetails.vue?vue&type=template&id=04961bfe&scoped=true&"
import script from "./StudioPodcastDetails.vue?vue&type=script&lang=js&"
export * from "./StudioPodcastDetails.vue?vue&type=script&lang=js&"
import style0 from "./StudioPodcastDetails.vue?vue&type=style&index=0&id=04961bfe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04961bfe",
  null
  
)

export default component.exports